import React from 'react';
import { View, Text, StyleSheet, Image } from '@react-pdf/renderer';
import logoBase64 from '../assets/food.jpg';


const styles = StyleSheet.create({
    outerContainer: {
        padding: 0,
        margin: 0,
    },
    headerRow: {
        flexDirection: 'row',
        alignItems: 'stretch', // Changed from 'center' to fill vertical space
        // borderBottom: '1px solid #000',
        marginLeft: -20,
        marginRight: -20,
        marginTop: -20,
        height: 100, // Fixed height matching logo height
    },
    logo: {
        width: '30%',
        height: '100%', // Fill container height
        margin: 0,
        padding: 0,
        objectFit: 'cover',
    },
    infoContainer: {
        flex: 1,
        textAlign: 'center',
        justifyContent: 'center',
        padding: 8,
        paddingTop: 15, // Add space only at the top of text content
    },
    resortName: {
        fontSize: 28,
        fontWeight: 'bold',
        color: '#4C52AD',
        marginBottom: 4,
        marginTop: -5, // Adjust title position
    },
    textLine: {
        fontSize: 10,
        color: '#4C52AD',
        marginBottom: 2,
    }
});




const PDFHeader = ({ data }) => {
    const h = data?.hotel_detail;
    if (!h) return null;
    return (
        <View style={styles.outerContainer}>
            <View style={styles.headerRow}>
                <Image
                    src={h.logoBase64 || h.logo || logoBase64}
                    style={styles.logo}
                />
                <View style={styles.infoContainer}>
                    <Text style={styles.resortName}>{h.name || 'Hotel'}</Text>
                    {h.address ? <Text style={styles.textLine}>{h.address}</Text> : null}
                    {h.location ? <Text style={styles.textLine}>{h.location}</Text> : null}
                    {h.contact ? <Text style={styles.textLine}>{h.contact}</Text> : null}
                    {h.gst_number ? <Text style={styles.textLine}>GST: {h.gst_number}</Text> : null}
                    {h.pan_number ? <Text style={styles.textLine}>PAN: {h.pan_number}</Text> : null}
                </View>
            </View>
        </View>
    );
};

export default PDFHeader;